import React, { useState } from 'react';
import "../styles/Component2.css"
import {  Element } from "react-scroll";

const Component2 = () => {

    const [selected,setSelected]=useState(null)

    const toggle = (i) => {
        if (selected == i){
            setSelected(null)
        }

        setSelected(i)
    }
    


  return (
    <Element name="faq-section" >
          <section id="faq-section" className="container_2">
      <h3  style={{ color:"black", fontSize:"62px" , fontFamily:"bold" }}>
      Frequently Asked Questions
      </h3>

      <div className='accordion_2'> 
        {data.map((item,i) => (
            <div className='item_2'>
                <div className='title_2' onClick={()=>toggle(i)}>
                    <h3>{item.question}</h3>
                    <span>{selected=== i ? "-" : "+"}</span>
                </div>
                <div className={selected=== i ? "content_show_2" : "content_2"}>
                    {item.answer}
                </div>

            </div>
        ))}
      </div>
      </section>
  
  </Element>
  
  );
};


const data = [
   { question: "How does UGC Creator work?",
    answer:"UGC Creator is a mobile app that leverages artificial intelligence to help users create high-quality, engaging user-generated content effortlessly. Users simply select an avatar from a range of customizable options and the app generates a realistic video featuring the avatar delivering the message."},
   { question: "How does UGC Creator work?",
    answer:"UGC Creator is a mobile app that leverages artificial intelligence to help users create high-quality, engaging user-generated content effortlessly. Users simply select an avatar from a range of customizable options and the app generates a realistic video featuring the avatar delivering the message."},
   { question: "How does UGC Creator work?",
    answer:"UGC Creator is a mobile app that leverages artificial intelligence to help users create high-quality, engaging user-generated content effortlessly. Users simply select an avatar from a range of customizable options and the app generates a realistic video featuring the avatar delivering the message."}

]

export default Component2;  
